import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Transaction } from '../models/transaction';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
})
export class DetailsComponent implements OnInit {
  detailsForm: FormGroup;
  locCodes = new FormControl('', Validators.required);
  locationCodes = ['001', '002', '003'];
  fromPicker: Date;
  toPicker: Date;
  matList = new FormControl('', Validators.required);
  matTile = new FormControl('', Validators.required);
  displayedColumns: string[] = ['item', 'cost'];
  transactions: Transaction[] = [
    { item: 'Cash', cost: 4 },
    { item: 'Card', cost: 5 },
    { item: 'Sodexo', cost: 2 }
  ];

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.detailsForm = this.fb.group({
      locCodes: ['', { validators: [Validators.required] }],
    });
  }

  GetLocationDetailsErrorMessage() {
    return this.locCodes.hasError('required') ? 'You must select a value' : '';
  }

  GetAmountDetailsErrorMessage() {
    return this.locCodes.hasError('required') ? 'You must select a value' : '';
  }

  /** Gets the total cost of all transactions. */
  getTotalCost() {
    return this.transactions
      .map((t) => t.cost)
      .reduce((acc, value) => acc + value, 0);
  }
}
